module.exports = __webpack_public_path__ + "static/left-img2-a3471fac621323122295facf26886dda.png";